import React from 'react';
import { ShiftIntervalCategory } from '@amzn/atoz-shiftapp-types';
import { ChipBackgroundColor } from '@amzn/atoz-web/Chip';
import { IconPeopleFill, IconPlus, IconMinus, IconSettings, IconClockFill, IconCalendar } from '@amzn/atoz-web/Icons';
import { useTranslation } from 'react-i18next';
export var useShiftIntervalMapping = function (category) {
    var t = useTranslation().t;
    switch (category) {
        case ShiftIntervalCategory.Breaks: {
            var label = t('shift_management_features_shift_interval_breaks');
            var iconColor = 'green70';
            var eventBlockColor = 'green10';
            var eventBlockBorderColor = 'green50';
            return {
                icon: React.createElement(IconClockFill, { color: iconColor, title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Green,
                    iconColor: iconColor,
                    eventBlockBorderColor: eventBlockBorderColor,
                    eventBlockColor: eventBlockColor
                },
                label: label
            };
        }
        case ShiftIntervalCategory.Meetings: {
            var label = t('shift_management_features_shift_interval_meetings');
            var iconColor = 'purple70';
            var eventBlockColor = 'purple10';
            var eventBlockBorderColor = 'purple50';
            return {
                icon: React.createElement(IconPeopleFill, { color: iconColor, title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Purple,
                    eventBlockBorderColor: eventBlockBorderColor,
                    iconColor: iconColor,
                    eventBlockColor: eventBlockColor
                },
                label: label
            };
        }
        case ShiftIntervalCategory.AdditionalTime: {
            var label = t('shift_management_features_shift_interval_additionalTime');
            var iconColor = 'yellow70';
            var eventBlockColor = 'yellow10';
            var eventBlockBorderColor = 'yellow50';
            return {
                icon: React.createElement(IconPlus, { color: iconColor, title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Yellow,
                    iconColor: iconColor,
                    eventBlockColor: eventBlockColor,
                    eventBlockBorderColor: eventBlockBorderColor
                },
                label: label
            };
        }
        case ShiftIntervalCategory.TimeOff: {
            var label = t('shift_management_features_shift_interval_timeOff');
            var iconColor = 'neutral70';
            var eventBlockColor = 'neutral10';
            var eventBlockBorderColor = 'neutral50';
            return {
                icon: React.createElement(IconMinus, { color: iconColor, title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Default,
                    iconColor: iconColor,
                    eventBlockBorderColor: eventBlockBorderColor,
                    eventBlockColor: eventBlockColor
                },
                label: label
            };
        }
        case ShiftIntervalCategory.Miscellaneous: {
            var label = t('shift_management_features_shift_interval_miscellaneous');
            var iconColor = 'pink70';
            var eventBlockColor = 'pink10';
            var eventBlockBorderColor = 'pink50';
            return {
                icon: React.createElement(IconSettings, { color: iconColor, title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Pink,
                    iconColor: iconColor,
                    eventBlockBorderColor: eventBlockBorderColor,
                    eventBlockColor: eventBlockColor
                },
                label: label
            };
        }
        case ShiftIntervalCategory.Work: {
            var label = t('shift_management_features_shift_interval_work');
            var iconColor = 'primary70';
            var eventBlockColor = 'primary10';
            var eventBlockBorderColor = 'primary50';
            return {
                icon: React.createElement(IconCalendar, { color: "primary70", title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Blue,
                    iconColor: iconColor,
                    eventBlockBorderColor: eventBlockBorderColor,
                    eventBlockColor: eventBlockColor
                },
                label: label
            };
        }
        default: {
            var label = t('shift_management_features_shift_interval_miscellaneous');
            var iconColor = 'pink70';
            var eventBlockColor = 'pink10';
            var eventBlockBorderColor = 'pink50';
            return {
                icon: React.createElement(IconSettings, { color: iconColor, title: label }),
                color: {
                    chipColor: ChipBackgroundColor.Pink,
                    iconColor: iconColor,
                    eventBlockBorderColor: eventBlockBorderColor,
                    eventBlockColor: eventBlockColor
                },
                label: label
            };
        }
    }
};
